<template>
  <div class="item-cells product-label" v-if="newExp.length > 0">
    <div class="item-cell" @click="showLabels">
      <div class="item-cell-bd item-left">
        <ul>
          <li v-for="(explanation, index) in newExp" :key="index">
            <i></i>
            <span>
              <span>{{ explanation.title }}</span>
            </span>
          </li>
        </ul>
      </div>
      <div class="more-ui">
        <p></p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import PROUDCT_TYPE from '@/router/home/components/product/product-intro/config'

export default {
  props: {
    product: {
      type: Object
    }
  },
  computed: {
    ...mapState(['serveExplanation']),
    newExp() {
      const lb = []
      if (
        this.product.isAnyTimeRefund === 0 &&
        this.product.isExpiredRefund === 0
      ) {
        lb.push({ title: '不可退', isGood: 0 })
      } else {
        if (this.product.isAnyTimeRefund === 1) {
          lb.push({ title: '随时退', isGood: 1 })
        }
        if (this.product.isExpiredRefund === 1) {
          lb.push({ title: '过期退', isGood: 1 })
        }
      }
      // }
      // if (this.product.isSchedule * 1 === 1) {
      //     lb.push({ title: '需预约', isGood: 1 })
      // } else {
      //     lb.push({ title: '免预约', isGood: 1 })
      // }
      if (+this.product.spuType === PROUDCT_TYPE.YU_ER)
        lb.push({ title: 'PICC承保', isGood: 1 })
      if (this.product.isPosPay * 1 === 1) {
        lb.push({ title: 'POS支付', isGood: 1 })
      }
      return lb
    },
    numSale() {
      let num = this.product.saleNum
      if (num > 9999) {
        num = `${parseFloat(Number(num / 10000).toFixed(1))}万`
      }
      return num
    }
  },
  methods: {
    // showActionsheet() {
    //     this.$store.commit('showActionSheet')
    // },
    ...mapMutations(['showActionSheet', 'changeView', 'setActionHeader']),
    showLabels() {
      this.changeView('recoveryServeExplain')
      this.setActionHeader({
        title: '服务说明'
      })
      this.showActionSheet()
      this.$$tracker('100101', '20000', 21001)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';

.product-label {
  padding: 0;
  background: #fff;
  border-bottom-right-radius: rem(20px);
  border-bottom-left-radius: rem(20px);

  .item-cell {
    padding: 0;
    height: rem(80px);
    @include border(top);
  }
  .sale-num {
    font-size: rem(24px);
    color: #4d4d4d;
  }
  .more-ui {
    width: rem(20px);
    height: rem(20px);
    > p {
      display: block;
      width: rem(20px);
      height: rem(20px);
      background: url('~@/assets/images/icon-more.png') no-repeat;
      background-size: 100% auto;
    }
  }
  .item-left {
    display: flex;
    align-items: center;
    line-height: rem(30px);
    label {
      font-size: rem(24px);
      color: #999999;
    }

    ul {
      position: relative;
      display: flex;
      margin: 0 rem(-6px);
      li {
        display: flex;
        align-items: center;
        > span {
          padding-left: rem(2px);
        }
      }
    }
    i {
      display: block;
      width: rem(36px);
      height: rem(30px);
      background: url('~@/assets/images/product/icon-label@3x.png') no-repeat;
      background-position: center;
      background-size: rem(24px) auto;
    }
  }
  .icon-more {
    color: #666;
  }

  li {
    align-items: center;
    position: relative;
    padding-right: rem(32px);
    font-size: rem(24px);
    color: #121212;
  }
  .item-cell-bd {
    height: 1.4em;
    // line-height: rem(30px);
    margin-right: rem(20px);
    margin-top: rem(2px);
    overflow: hidden;
  }
  .icon-more {
    width: rem(32px);
    height: rem(30px);
  }
}
</style>
